import { Link } from "react-router-dom";
import { useState } from "react";
import api from "@/lib/api";
import { useContent } from "@/context/ContentContext";

export default function Footer() {
    const [email, setEmail] = useState("");
    const [state, setState] = useState("idle");
    const { get } = useContent();

    const onSubscribe = async (e) => {
        e.preventDefault();
        if (!email) return;
        setState("loading");
        try {
            await api.post("/newsletter", { email });
            setState("ok");
            setEmail("");
        } catch (err) {
            setState("err");
        }
    };

    return (
        <footer className="rax-footer" data-testid="site-footer">
            <div className="rax-footer-inner">
                <div className="newsletter" style={{ padding: 0, background: "transparent", marginBottom: 48 }}>
                    <div className="newsletter-inner">
                        <div className="eyebrow" style={{ color: "var(--sand)", marginBottom: 12 }}>
                            {get("footer.newsletter_eyebrow", "The Edit — first look")}
                        </div>
                        <h3 style={{ color: "var(--ivory)" }}>{get("footer.newsletter_title", "New pieces, quietly delivered.")}</h3>
                        <p>
                            {get("footer.newsletter_body", "The best of each drop, before it hits the site — a short weekly note from RAX.")}
                        </p>
                        <form className="newsletter-form" onSubmit={onSubscribe} data-testid="footer-newsletter-form">
                            <label htmlFor="footer-email" className="sr-only">
                                Email
                            </label>
                            <input
                                id="footer-email"
                                type="email"
                                placeholder="your@email.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                data-testid="footer-newsletter-email"
                            />
                            <button type="submit" disabled={state === "loading"} data-testid="footer-newsletter-submit">
                                {state === "ok" ? "You're on the list" : "Subscribe"}
                            </button>
                        </form>
                        {state === "err" && (
                            <div className="newsletter-note" style={{ color: "#e0b5a5" }}>
                                Something went wrong. Please try again.
                            </div>
                        )}
                        <div className="newsletter-note">By subscribing you agree to our privacy policy.</div>
                    </div>
                </div>

                <div className="rax-footer-top">
                    <div>
                        <div className="rax-footer-mark">RAX</div>
                        <div className="eyebrow" style={{ color: "var(--sand)", marginBottom: 12 }}>
                            The Edit
                        </div>
                        <p className="rax-footer-tagline">{get("footer.tagline", "Current Season, In Circulation.")}</p>
                        <p className="rax-footer-tagline">{get("footer.location_label", "Curated resale · London")}</p>
                    </div>
                    <div>
                        <h4>Shop</h4>
                        <ul>
                            <li><Link to="/shop">All Pieces</Link></li>
                            <li><Link to="/edits">The Edits</Link></li>
                            <li><Link to="/shop?category=Outerwear">Outerwear</Link></li>
                            <li><Link to="/shop?category=Tailoring">Tailoring</Link></li>
                            <li><Link to="/shop?category=Bags">Bags</Link></li>
                        </ul>
                    </div>
                    <div>
                        <h4>The House</h4>
                        <ul>
                            <li><Link to="/about">Our Story</Link></li>
                            <li><Link to="/sell">Sell With Us</Link></li>
                            <li><Link to="/how-it-works">How It Works</Link></li>
                            <li><Link to="/contact">Contact</Link></li>
                        </ul>
                    </div>
                    <div>
                        <h4>Care</h4>
                        <ul>
                            <li><Link to="/legal/returns">Shipping & Returns</Link></li>
                            <li><Link to="/legal/terms">Terms of Sale</Link></li>
                            <li><Link to="/legal/privacy">Privacy</Link></li>
                            <li><Link to="/legal/consignor">Consignor Agreement</Link></li>
                            <li><Link to="/legal/cookies">Cookies</Link></li>
                        </ul>
                    </div>
                </div>

                <div className="rax-footer-bottom">
                    <div>© {new Date().getFullYear()} RAX The Edit</div>
                    <div>hello@raxtheedit.com</div>
                </div>
            </div>
        </footer>
    );
}
